var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"style",class:_vm.cssClasses},[(!_vm.isLink)?[_vm._v(_vm._s(_vm.content.text))]:[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank","rel":"noopener noreferrer nofollow"}},[_vm._v(_vm._s(_vm.content.text))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }